import * as Sentry from "@sentry/nextjs";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { useSWRConfig } from "swr";

import { useErrorToaster } from "src/common/components/ErrorDetails";
import { client, endpoint } from "src/lib/bridgeClient";
import { SERVER_COMM_ERROR } from "src/lib/error";

export type CreateDiskDTO = {
  name: string;
  size: number;
  username: string;
};

const postDisk = async (client: Client, disk: CreateDiskDTO) => {
  return await client(endpoint.getMyDisks, "POST", disk);
};

export const useCreateDisk = () => {
  const toastError = useErrorToaster();
  const { mutate } = useSWRConfig();

  return async (disk: CreateDiskDTO): Promise<AxiosResponse> => {
    let response: AxiosResponse;

    try {
      response = await postDisk(client, disk);

      mutate(endpoint.getMyDisks);

      toast.success(`Disk created: ${disk.name}`);
    } catch (error) {
      if (error?.response?.data?.error) {
        toastError(`Failed to create disk: ${disk.name}`, error?.response?.data?.error);
      } else {
        toast.error(`Request failed: ${SERVER_COMM_ERROR}`);
        Sentry.captureException(error);

        return error.response;
      }
    }

    return response;
  };
};
